export default __webpack_public_path__ + "static/media/modal8.a4db134a.jpg";